import * as types from '../constants/actionTypes';
import * as contact from '../models/contact';

function sendEmailAction(request) {
  return {
    type: types.SEND_EMAIL,
    payload: request,
  };
}

export function sendEmail(nameEmailMessage) {
  return sendEmailAction(contact.sendEmail(nameEmailMessage));
}


// WEBPACK FOOTER //
// ./src/actions/contactActions.js